import { render, staticRenderFns } from "./AppBackIndex.vue?vue&type=template&id=2ddc43c3&scoped=true"
import script from "./AppBackIndex.vue?vue&type=script&lang=js"
export * from "./AppBackIndex.vue?vue&type=script&lang=js"
import style0 from "./AppBackIndex.vue?vue&type=style&index=0&id=2ddc43c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc43c3",
  null
  
)

export default component.exports